import { useContext } from 'react';
import { DesktopNavigationContext } from './DesktopNavigationProvider';
export const useDesktopNavigation = () => {
    const context = useContext(DesktopNavigationContext);
    if (!context) {
        throw new Error('useDesktopNavigation hook must be used as a child to <DesktopNavigationProvider />');
    }
    return context;
};
